
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { GatewayApi } from "./api";
import GatewayInfo from "./GatewayInfo";

interface GatewayInfoWidgetProps {
  id: string;
  header: string;
}

const GatewayWidget = (props: GatewayInfoWidgetProps) => {
  const [machinesGatewayInfo, updateMachinesGatewayInfo] = useState([]);
  const [customerGatewayInfo, updateCustomerGatewayInfo] = useState([]);
  const [gatewayInfoLoading, updateLoadingGatewayInfo] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (globalParams.customerID != null) {
      updateLoadingGatewayInfo(true);
      getGatewayInfo(globalParams.customerID, signal);
    }

    return () => controller.abort();
  }, [globalParams.customerID]);

  const getGatewayInfo = (cId, signal) => {
    let params: any = { customerId: cId };
    GatewayApi.getCustomerGatewayInfo(params, signal)
      .then((response: any) => {
       // console.log(response);
        updateCustomerGatewayInfo([response[0]]);
        if (response && response.length > 0) {
          const newArray = response.slice(1); // This removes the first item
          updateMachinesGatewayInfo(newArray);
        }
        updateLoadingGatewayInfo(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateLoadingGatewayInfo(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const renderCustomerGatewayInfo = () => {
    if (customerGatewayInfo[0].gatewayType == "None found") {
      return (
        <div>
          <h5>Customer Remote Gateway</h5>
          No Remote Gateway at customer level. Check for remote gateways at
          machine level below.
        </div>
      );
    }
    return (
      <div>
        <h5>Customer Remote Gateway</h5>
        <GatewayInfo gateways={customerGatewayInfo} />
      </div>
    );
  };
  const renderMachineGatewayInfo = () => {
    if (machinesGatewayInfo.length == 0) {
      return (
        <div>
          <h5>Machine Remote Gateway</h5>
          None found
        </div>
      );
    }
    return (
      <div>
        <h5>Machine Remote Gateway</h5>
        <GatewayInfo gateways={machinesGatewayInfo} />
      </div>
    );
  };
  if (gatewayInfoLoading) {
    return <Spinner text="remote gateway information" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }

  return (
    <div>
      {renderCustomerGatewayInfo()}
      {renderMachineGatewayInfo()}
    </div>
  );
};

export default GatewayWidget;
